import { Divider } from 'antd';

import { Select } from '@style/global-style.app';

import { Input } from '@atom/form/input/input';
import { FormSwitcher } from '@component/form-switcher/form-switcher';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { useNewWebhookForm } from '@form/new-webhook/new-webhook.form-hook';
import { BaseFormInterface } from '@interface/form/base-form.interface';

import { newWebhookFormValidation } from './new-webhook.form-validation';

export const NewWebhookForm = ({ form, error }: BaseFormInterface) => {
  const { enums, events } = useNewWebhookForm({ form });

  return (
    <Form autoComplete='off' form={form} layout='vertical' name='webhook'>
      <Form.Item label='Enable' name='status' rules={[{ required: true }]}>
        <FormSwitcher form={form} name='status' defaultChecked />
      </Form.Item>
      <Form.Item label='Delivery url' name='deliveryUrl' rules={[{ required: true }, newWebhookFormValidation]}>
        <Input placeholder='Please input delivery url' />
      </Form.Item>
      <Form.Item label='Description' name='description'>
        <Input.TextArea placeholder='Please input description' />
      </Form.Item>
      <Divider orientation='left'>Webhooks</Divider>
      <Form.Item label='Unify API' name='unifiedApi' rules={[{ required: true }]}>
        <Select options={enums as any} />
      </Form.Item>
      <Form.Item label='Events' name='events' rules={[{ required: true }]}>
        <Select disabled={events.length === 0} mode='multiple' options={events} />
      </Form.Item>
      <FormError error={error} errorField='deliveryUrl' />
    </Form>
  );
};
